var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconITooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1981 16.05V8.835H9.80305V16.05H11.1981ZM9.48805 6.105C9.48805 6.66 9.93805 7.11 10.4931 7.11C11.0631 7.11 11.5131 6.66 11.5131 6.105C11.5131 5.535 11.0631 5.085 10.4931 5.085C9.93805 5.085 9.48805 5.535 9.48805 6.105Z",
    fill: "#696969"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    stroke: "#696969",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconITooltip);
export default __webpack_public_path__ + "static/media/Icon_i_Tooltip.f36f8ee7b7729fbadb7c995c870a887f.svg";
export { ForwardRef as ReactComponent };